import { Directive } from '@angular/core';
import { BrnSheetClose } from '@spartan-ng/brain/sheet';

@Directive({
    host: { 'data-slot': 'sheet-close' },
    hostDirectives: [BrnSheetClose],
    selector: 'button[hlmSheetClose]',
})
export class HlmSheetClose {}
